import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { InfoIcon } from 'foundations-assets';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Small } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PortalCapacityStatus = ({
  portalCapacityLimit,
  portalCapacityLoad
}) => {
  if (portalCapacityLoad < portalCapacityLimit) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    paddingInlineStart: "200",
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.agent-status.statusPopover.header.limitLiveChat",
        options: {
          portalCapacityLoad,
          portalCapacityLimit
        }
      }),
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(InfoIcon, {
            alignWithText: true
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: portalCapacityLoad === portalCapacityLimit ? 'routing-ui.agent-status.capacityLimits.fullCapacity' : 'routing-ui.agent-status.capacityLimits.overCapacityInfo'
          })]
        })
      })
    })
  });
};
PortalCapacityStatus.displayName = 'PortalCapacityStatus';